import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import ContragentyPage from './pages/spravochniki/ContragentyPage';
import NomenklaturyPage from './pages/spravochniki/NomenklaturyPage';
import DogovorPage from './pages/documenty/DogovorPage';
import ResponsiveAppBar from './components/UI/ResponsiveAppBar';
import Error404Page from './pages/Error404Page';
import OrganizationPage from './pages/spravochniki/OrganizationPage';
import RaschetPage from './pages/documenty/RaschetPage';
import OsvRepPage from './pages/reports/OsvRepPage';
import NomenklaturaRepPage from './pages/reports/NomenklaturaRepPage';
import PaymentPage from './pages/documenty/PaymentPage';
import NalogRepPage from './pages/reports/NalogRepPage';
import CategoryPage from './pages/spravochniki/CategoryPage';
import PaymentCodePage from './pages/spravochniki/PaymentCodePage';
import K1Page from './pages/spravochniki/K1Page';
import K2Page from './pages/spravochniki/K2Page';
import K3Page from './pages/spravochniki/K3Page';
import K4Page from './pages/spravochniki/K4Page';
import KiPage from './pages/spravochniki/KiPage';
import KzPage from './pages/spravochniki/KzPage';
import SrokiDogovorPage from './pages/reports/SrokiDogovorPage';
import ContragentRepPage from './pages/reports/ContragentRepPage';
import LoginPage from './pages/LoginPage';
import { PrivateRoute } from './PrivateRoute';
import Nomenklatury2Page from './pages/spravochniki/Nomenklatura2Page'

const protectedRoutes = [
  { path: 'home', Component: HomePage },
  { path: 'contragenty', Component: ContragentyPage },
  { path: 'nomenklatury', Component: NomenklaturyPage },
  { path: 'nomenklatury2', Component: Nomenklatury2Page },
  { path: 'organization', Component: OrganizationPage },
  { path: 'dogovor', Component: DogovorPage },
  { path: 'raschet', Component: RaschetPage },
  { path: 'osv', Component: OsvRepPage },
  { path: 'otchetPoObjectam', Component: NomenklaturaRepPage },
  { path: 'payment', Component: PaymentPage },
  { path: 'otchetPoNalogam', Component: NalogRepPage },
  { path: 'category', Component: CategoryPage },
  { path: 'paymentCode', Component: PaymentCodePage },
  { path: 'k1', Component: K1Page },
  { path: 'k2', Component: K2Page },
  { path: 'k3', Component: K3Page },
  { path: 'k4', Component: K4Page },
  { path: 'ki', Component: KiPage },
  { path: 'kz', Component: KzPage },
  { path: 'sroki', Component: SrokiDogovorPage },
  { path: 'otchetPoContragentu', Component: ContragentRepPage },
];

function AppRoutes({ isAuth }) {

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        {protectedRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <PrivateRoute
                isAuth={isAuth}
                component={
                  <>
                    <ResponsiveAppBar />
                    <Component />
                  </>
                }
              />
            }
          />
        ))}
        <Route path="*" element={<Error404Page />} />
      </Routes>
    </>
  );
}

export default AppRoutes;
